import imageSizes from '@/utils/helpers/image-sizes-constants';
import { resizeImage } from '@/utils/helpers/image';

export function thumbnail(url, sizeName) {
  if (!url) return '';
  if (!sizeName) sizeName = 'medium';
  return resizeImage(url, imageSizes[sizeName.toUpperCase()]);
}
